module.exports = __webpack_public_path__ + "img/3b12007.svg";